import React from 'react';
import { Radio } from 'antd';

const Switcher = ({
  options,
  selectedOption,
  onSelectOption,
}) => {

  return (
    <Radio.Group
      options={options}
      onChange={(e) => onSelectOption(e.target.value)}
      value={selectedOption}
      optionType="button"
      buttonStyle="solid"
    />
  )
}

export default Switcher;
